/**
 * Tenant Settings API functions
 */

import { tenantApi } from './client';

export interface TenantSettingsData {
  company_info: {
    company_name?: string;
    industry?: string;
    email?: string;
    phone?: string;
    address?: string;
    website?: string;
  };
  branding: {
    primary_color?: string;
    logo_url?: string;
  };
  security: {
    two_factor_required?: boolean;
    data_retention_days?: number;
  };
  system: {
    notifications_enabled?: boolean;
    maintenance_mode?: boolean;
  };
}

export async function getTenantSettings(): Promise<TenantSettingsData> {
  const response = await tenantApi.get<TenantSettingsData>('/settings');
  return response.data;
}

export async function updateTenantSettings(
  data: Partial<TenantSettingsData>
): Promise<TenantSettingsData> {
  const response = await tenantApi.patch<TenantSettingsData>('/settings', data);
  return response.data;
}
